import { render } from "./damage-table.vue?vue&type=template&id=cb101c16"
import script from "./damage-table.vue?vue&type=script&lang=js"
export * from "./damage-table.vue?vue&type=script&lang=js"

import "./damage-table.vue?vue&type=style&index=0&id=cb101c16&lang=css"
script.render = render

export default script